module.exports = __webpack_public_path__ + "static/images/6c9b47d6ce3a157ad49746499799531f.png";